module.exports = __webpack_public_path__ + "static/media/result_banner_en.b045a7e7.png";